import React from 'react';
import moment from "moment";
import styled from "styled-components";
import { BodyVerySmall } from '@shared/ui/atoms/fonts/Body';
import Colours from '@shared/ui/atoms/Colours';
import { useTranslation } from "react-i18next";
import { Column } from '@shared/ui/atoms/StructuralLayout';
import { useSelector } from "react-redux";
import { selectConfig } from '@shared/store/config.duck';

export function LeaveBreakdownList(props: Props) {
  const {usersHolidayInfo} = props;
  const {t} = useTranslation();
  const config = useSelector(selectConfig);

  const hasCarryOver = config.autoCarryOverEnabled;
  const hasCarryOverExpiry = hasCarryOver && !!config.autoCarryOverExpiryMonth && !!config.autoCarryOverExpiryDay;
  const carryOverExpiryDate = hasCarryOverExpiry
    ? moment().month(config.autoCarryOverExpiryMonth - 1).date(config.autoCarryOverExpiryDay).format('MMM D')
    : '';
  const totalIncludesExpiringLeave = hasCarryOverExpiry && usersHolidayInfo.carriedOverDays > 0;

  console.log(usersHolidayInfo)

  return (
    <Container>
      <div>
        <Row>
          <BodyVerySmall colour={Colours.black}>{t('allowance.breakdown-basic')}</BodyVerySmall>
          <BodyVerySmall style={{textTransform: 'lowercase'}} colour={Colours.darkGrey}>{t('allowance.days', {days: usersHolidayInfo.usersHolidayAllowance})}</BodyVerySmall>
        </Row>
        {usersHolidayInfo.additionalDays > 0 && <Row>
          <BodyVerySmall colour={Colours.black}>{t('allowance.breakdown-additional')}</BodyVerySmall>
          <BodyVerySmall style={{textTransform: 'lowercase'}} colour={Colours.darkGrey}>{t('allowance.days', {days: usersHolidayInfo.additionalDays})}</BodyVerySmall>
        </Row>}
        {hasCarryOver && <Row>
          <Column>
            <BodyVerySmall colour={Colours.black}>{t('allowance.breakdown-carried-over')}</BodyVerySmall>
            {hasCarryOverExpiry && <BodyVerySmall colour={Colours.darkGrey}>{t('allowance.breakdown-expires', {date: carryOverExpiryDate})}</BodyVerySmall>}
          </Column>
          <BodyVerySmall style={{textTransform: 'lowercase'}} colour={Colours.darkGrey}>{t('allowance.days', {days: usersHolidayInfo.carriedOverDays})}</BodyVerySmall>
        </Row>}
      </div>
      <TotalAllowanceContainer>
        <BodyVerySmall weight={700} colour={Colours.black}>
          {t('allowance.breakdown-total')}
        </BodyVerySmall>
        <BodyVerySmall weight={700} colour={Colours.blue} style={{textTransform: 'lowercase'}}>{t('allowance.days', {days: usersHolidayInfo.totalAllowanceIncludingAllCarriedOverLeave})}</BodyVerySmall>
      </TotalAllowanceContainer>
    </Container>
  )
}

interface Props {
  usersHolidayInfo: any;
}

const Row = styled.div`
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid ${Colours.lightGrey};
  margin-bottom: 6px;
  padding-bottom: 6px;
  &:last-child {
    border: none !important;
  }
`

const TotalAllowanceContainer = styled.div`
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid ${Colours.darkGrey};
  border-top: 1px solid ${Colours.darkGrey};
  padding: 8px 0;
`

const Container = styled.div`
  margin-top: 24px;
  margin-bottom: 32px;
`

const ExpiryAsterisk = styled.span`
  margin-left: 2px;
  color: ${Colours.blue};
  cursor: help;
`
